import CacheStore from 'bz-utilities/modules/stores/cached-map-store';
import { computed } from 'mobx';
import type { SkillResponse } from 'tm3-core/api.dtos';

class SkillsStore extends CacheStore<SkillResponse> {
  constructor() {
    super('skills');
  }

  @computed
  get forDropdown() {
    return this.All.map((s) => {
      return { text: s.name, payload: s.id };
    });
  }
}
export default SkillsStore;
